import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  subscriptionActions,
  subscriptionSelectors
} from '../../../store/modules/subscription';

const useFetchSubscriptionHistory = () => {
  const dispatch = useDispatch();
  const isFetched = !!useSelector(subscriptionSelectors.selectHistory);

  useEffect(() => {
    !isFetched && dispatch(subscriptionActions.fetchSubscriptionHistory());
  }, [isFetched]);
};

export default useFetchSubscriptionHistory;
